import React, {Component} from 'react';
import classNames from 'classnames';
import renderHTML from 'react-render-html';
import { bindActionCreators, compose } from "redux"
import {connect} from 'react-redux';
import * as Actions from '../actions/index';

import Article from './main/article';
import Empty from './main/empty';
import NavBar from '../containers/parts/NavBar';

class MenuButton extends Component {
	
	constructor(props) {
	    super(props);
	    // This binding is necessary to make `this` work in the callback
	    this.handleClick = this.handleClick.bind(this);
	}
	
	
	componentDidUpdate(){
		if ( this.props.active ) {
			this.props.actions.setSelectedCat( this.props.id );
			this.props.actions.fetchCategoryPosts('cc-posts', this.props.catID);
		}

	}
		
	handleClick(){
		//console.log(this);
		this.props.actions.fetchCategoryPosts('cc-posts', this.props.catID);
		this.props.actions.setSelectedCat( this.props.id );
	}

	render() {
		var classes = classNames({
			'btn': true,
			'btn-light' : !this.props.id === this.props.selectedCat,
			'btn-warning': this.props.id === this.props.selectedCat, 
		});

		return(
			<button className={classes} onClick={this.handleClick}>{ renderHTML( this.props.name ) }</button> 
		);
		
	}
}


function mapStateToProps(state) {
	return {
		cat: state.cat,
		selectedCat: state.selectedCat
	};
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MenuButton)


// WEBPACK FOOTER //
// ./src/components/menuButton.js